<div class="dashboardWidgetContainer">
    <h2>{{ 'dashboard.batchOperations.title' | translate }}</h2>

    <div class="batchOperationsContainer listContainer">
        <div class="listHeader">{{ 'dashboard.batchOperations.header' | translate }}</div>
        <ul class="list">
            @for (operation of batchOperations; track operation.operationName) {
                <li class="listItem">
                    <form [formGroup]="$any(fileForm)">
                        <div class="file">
                            <label for="file">{{ operation.translationPath | translate }}</label>
                            @if (operation.isInProgress) {
                                <button
                                    disabled
                                    class="button icon"
                                    title="{{ 'notifications.statuses.tooltips.BATCH_OPERATION_IN_PROGRESS' | translate }}"
                                >
                                    <i class="fal fa-upload"></i>
                                    <span>{{ 'generalKeywords.upload' | translate }}</span>
                                </button>
                            } @else {
                                <app-file-upload
                                    id="file"
                                    formControlName="file"
                                    [settings]="batchOperationsSettings"
                                    (fileChangedEvent)="uploadBatchOperation($any($event), operation.batchOperationType)"
                                />
                            }
                        </div>
                    </form>
                </li>
            }
        </ul>
    </div>
</div>
